import { OpsType } from '@weave/schema-gen-ts/dist/shared/organization/ops_type.pb';
import { Options, http } from '@frontend/fetch';

const baseUrl = 'payments/';

export const queryKeys = {
  getStripeExpressPublicKey: 'stripeExpressPublicKey',
};

export type StripeExpressPublicKeyResponse = {
  _links: { root: { href: string } };
  body: { stripeExpressPublicKey: string };
};

export const getStripeExpressPublicKey = async (locationType: keyof typeof OpsType, options?: Options) =>
  await http.get<StripeExpressPublicKeyResponse>(`${baseUrl}api?locationType=${locationType}`, options).then((res) => {
    if (res && res.body) {
      return res.body.stripeExpressPublicKey;
    }
    throw new Error('No stripeExpressPublicKey found');
  });
